import formulaApi from '@/services/plataforma/formula';

export default {
  fetchVariablesForAverageWithBlockOrigin(_, { courseId, categoryId }) {
    return formulaApi.fetchVariablesForAverageWithBlockOrigin({ courseId, categoryId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  fetchAverageFormula(_, { courseId, categoryId }) {
    return formulaApi.fetchAverageFormula({ courseId, categoryId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  fetchResultFormula(_, { courseId }) {
    return formulaApi.fetchResultFormula({ courseId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  fetchResultFormulaVariables(_, { courseId }) {
    return formulaApi.fetchResultFormulaVariables({ courseId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  fetchFinalFormula(_, { courseId }) {
    return formulaApi.fetchFinalFormula({ courseId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  upsertAverageFormula(_, { courseId, categoryId, body }) {
    return formulaApi.upsertAverageFormula(courseId, categoryId, body)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  upsertFinalFormula(_, { courseId, body }) {
    return formulaApi.upsertFinalFormula(courseId, body)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  upsertResultFormula(_, { courseId, body }) {
    return formulaApi.upsertResultFormula(courseId, body)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchCalculateEnrollmentAverageGrade(_, { courseId, categoryId, enrollmentId }) {
    return formulaApi.patchCalculateEnrollmentAverageGrade(courseId, categoryId, enrollmentId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchCalculateEnrollmentFinalGrade(_, { courseId, enrollmentId }) {
    return formulaApi.patchCalculateEnrollmentFinalGrade(courseId, enrollmentId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchCalculateEnrollmentModule(_, { courseId, categoryId, gradeBookId, enrollmentId }) {
    return formulaApi.patchCalculateEnrollmentModule(courseId, categoryId, gradeBookId, enrollmentId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchCalculateEnrollmentResult(_, { courseId, enrollmentId }) {
    return formulaApi.patchCalculateEnrollmentResult(courseId, enrollmentId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchCalculateGrade(_, { courseId }) {
    return formulaApi.patchCalculateGrade(courseId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  }
};
